import React from 'react'

import { useTheme } from '@mui/material'

interface Props {
    children?: React.ReactNode
}

export const Mention: React.FC<Props> = (props) => {
    const theme = useTheme()
    return (
        <span style={{ color: theme.palette.info.main }}>{props.children}</span>
    )
}
